(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["bb-cart-engraving"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bbCartEngraving) return;
    window.__bbCartEngraving = true;

    var TYPE_LABELS = ['Blade Engraving?', 'Which Engraving Would You Like?', 'Spear Engraving?'];
    var NONE_VALUES = /^(none|no|n\/a|not selected|-+)?$/i;
    var SKIP_TYPES = /logo|image|upload/i;
    var COPY = {
      toggle: 'Add blade engraving',
      from: 'from',
      typeLegend: 'Engraving type',
      textLabel: 'What should we engrave?',
      textHint: 'Font, placement and orientation are chosen by our engravers. Proofs are not provided.',
      submit: 'Add engraving',
      adding: 'Adding…',
      cancel: 'Cancel',
      adds: 'Adds',
      needText: 'Please enter the text to engrave.',
      failed: 'Sorry, the engraving could not be added. Please try again or add it from the product page.'
    };

    var drafts = new Map(); /* line key -> { type, size, length, text, open } */
    var cartCache = null;
    var cartPromise = null;
    var frame = null;
    var busy = false;
    var loadedOptionSets = [];
    var optionsPromise = null;
    var optionsAttempted = false;

    function money(n) {
      return '$' + (Math.round(n * 100) / 100).toFixed(2).replace(/\.00$/, '');
    }

    function price(v) {
      var n = parseFloat(v && v.price);
      return isNaN(n) ? 0 : n;
    }

    function optionSets() {
      var s = window.ap_front_settings;
      var list = s && s.config && s.config.optionset;
      return Array.isArray(list) && list.length ? list : loadedOptionSets;
    }

    function readJsonObject(source, start) {
      var depth = 0, quoted = false, escaped = false;
      for (var i = start; i < source.length; i++) {
        var ch = source[i];
        if (quoted) {
          if (escaped) escaped = false;
          else if (ch === '\\') escaped = true;
          else if (ch === '"') quoted = false;
        } else if (ch === '"') quoted = true;
        else if (ch === '{') depth++;
        else if (ch === '}' && --depth === 0) {
          try { return JSON.parse(source.slice(start, i + 1)); } catch (e) { return null; }
        }
      }
      return null;
    }

    function parseOptionSets(source) {
      var result = [];
      var pattern = /(?:window\.)?ap_front_settings\.config\[\s*['"]optionset['"]\s*\]\.push\(\s*(?=\{)/g;
      var match;
      while ((match = pattern.exec(source))) {
        var set = readJsonObject(source, pattern.lastIndex);
        if (set && Array.isArray(set.options)) result.push(set);
      }
      return result;
    }

    function loadOptionSets(cart) {
      if (optionSets().length) return Promise.resolve(optionSets());
      if (optionsPromise) return optionsPromise;
      if (optionsAttempted) return Promise.resolve([]);
      var item = (cart.items || []).find(function (line) { return line.handle; });
      if (!item) return Promise.resolve([]);
      optionsAttempted = true;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      var url = root + 'products/' + encodeURIComponent(item.handle);
      optionsPromise = fetch(url, { credentials: 'same-origin', cache: 'no-store' })
        .then(function (response) { return response.ok ? response.text() : ''; })
        .then(function (source) { loadedOptionSets = parseOptionSets(source); return loadedOptionSets; })
        .catch(function () { return []; })
        .then(function (sets) { optionsPromise = null; return sets; });
      return optionsPromise;
    }

    function textMatch(compare, haystack, needle) {
      haystack = String(haystack || '').toLowerCase();
      needle = String(needle || '').toLowerCase();
      var hit;
      switch (compare) {
        case 'contains': hit = haystack.indexOf(needle) !== -1; break;
        case 'does_not_contain': hit = haystack.indexOf(needle) === -1; break;
        case 'equals': case 'is': hit = haystack === needle; break;
        case 'not_equals': case 'is_not': hit = haystack !== needle; break;
        case 'starts_with': hit = haystack.indexOf(needle) === 0; break;
        case 'ends_with': hit = needle.length ? haystack.slice(-needle.length) === needle : false; break;
        default: hit = null;
      }
      return hit;
    }

    /* Mirrors Aris's automated assignment as far as the cart can see it.
       Anything the cart cannot evaluate (tags, collections) counts as a miss,
       so the offer is withheld rather than shown wrongly. */
    function setApplies(set, item) {
      var pid = String(item.product_id);
      if (Array.isArray(set.exclude_products) && set.exclude_products.map(String).indexOf(pid) !== -1) return false;
      if (set.type === 'manual' || (Array.isArray(set.products) && set.products.length)) {
        return Array.isArray(set.products) && set.products.map(String).indexOf(pid) !== -1;
      }
      var rule = set.conditional_applying_product;
      if (!rule || !Array.isArray(rule.conditions) || !rule.conditions.length) return false;
      var results = rule.conditions.map(function (c) {
        var subject;
        if (c.type === 'title') subject = item.product_title;
        else if (c.type === 'vendor') subject = item.vendor;
        else if (c.type === 'product_type' || c.type === 'type') subject = item.product_type;
        else return false;
        var r = textMatch(c.keywordCompareType, subject, c.selector);
        return r === null ? false : r;
      });
      return rule.type === 'any' ? results.some(Boolean) : results.every(Boolean);
    }

    function findTypeOption(set) {
      return (set.options || []).find(function (o) {
        return o && TYPE_LABELS.indexOf(o.label_product) !== -1;
      });
    }

    function controlsOption(condition, typeOption) {
      return condition.field === typeOption.label_product ||
        condition.field_label === typeOption.label_product ||
        (typeOption.key && condition.field_option_key === typeOption.key);
    }

    function conditionMet(option, chosenType, typeOption) {
      var logic = option.conditional_logic;
      if (!logic || !Array.isArray(logic.condition_items) || !logic.condition_items.length) return true;
      var hits = logic.condition_items.map(function (ci) {
        if (!controlsOption(ci, typeOption)) return false;
        var v = String(ci.value || '').toLowerCase();
        var t = String(chosenType || '').toLowerCase();
        if (ci.type === 'contains') return t.indexOf(v) !== -1;
        if (ci.type === 'equals' || ci.type === 'is') return t === v;
        if (ci.type === 'not_contain' || ci.type === 'not_contains' || ci.type === 'does_not_contain') return t.indexOf(v) === -1;
        return false;
      });
      return logic.logic === 'all' ? hits.every(Boolean) : hits.some(Boolean);
    }

    function engravingPlan(item) {
      var typeOpt = null, set = null;
      optionSets().some(function (s) {
        var o = findTypeOption(s);
        if (o && o.type === 'radio' && setApplies(s, item)) { typeOpt = o; set = s; return true; }
        return false;
      });
      if (!typeOpt) return null;
      var types = (typeOpt.option_values || []).filter(function (v) {
        return v && v.value && !NONE_VALUES.test(v.value) && !SKIP_TYPES.test(v.value);
      });
      if (!types.length) return null;
      var followers = (set.options || []).filter(function (o) {
        return o !== typeOpt && o.conditional_logic && (o.conditional_logic.condition_items || []).some(function (ci) {
          return controlsOption(ci, typeOpt);
        });
      });
      var radios = followers.filter(function (o) { return o.type === 'radio' || o.type === 'button_single' || o.type === 'button'; });
      var text = followers.find(function (o) { return o.type === 'textarea' || o.type === 'text' || o.type === 'input'; });
      if (!text) return null;
      return { set: set, typeOpt: typeOpt, types: types, radios: radios, text: text };
    }

    function defaultValue(option) {
      var id = option.option_default_value;
      var v = (option.option_values || []).find(function (x) { return x.value_id === id; });
      return v || (option.option_values || [])[0] || null;
    }

    function readCart(force) {
      if (cartCache && !force) return Promise.resolve(cartCache);
      if (cartPromise) return cartPromise;
      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      cartPromise = fetch(root + 'cart.js', { headers: { Accept: 'application/json' }, cache: 'no-store' })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (c) { cartCache = c; return c; })
        .catch(function () { return null; })
        .then(function (c) { cartPromise = null; return c; });
      return cartPromise;
    }

    function hasEngraving(item) {
      return TYPE_LABELS.some(function (label) {
        var value = item.properties && item.properties[label];
        return !!(value && !NONE_VALUES.test(String(value).trim()));
      });
    }

    function lineElements() {
      var cart = document.querySelector('.site-header__cart');
      if (!cart) return [];
      return [].slice.call(cart.querySelectorAll('.bb-native-cart-item'));
    }

    function lineLink(el) {
      var a = el.querySelector('.dyn-lineitem-title-text-link') || el.querySelector('a[href*="/products/"]');
      var href = a && a.getAttribute('href');
      var out = { variant: null, handle: null, title: (a && a.textContent || '').trim() };
      if (!href) return out;
      try {
        var u = new URL(href, location.href);
        out.variant = u.searchParams.get('variant');
        var m = u.pathname.match(/\/products\/([^\/?#]+)/);
        out.handle = m ? m[1] : null;
      } catch (e) {}
      return out;
    }

    /* Pair drawer rows with cart lines in document order: by variant id when
       the title link carries one, else by product handle, else by title. */
    function matchLines(cart) {
      var used = {};
      var items = cart.items || [];
      function take(test) {
        var hit = items.find(function (it) { return !used[it.key] && test(it); }) || null;
        if (hit) used[hit.key] = true;
        return hit;
      }
      return lineElements().map(function (el) {
        var link = lineLink(el);
        var item = null;
        var directKey = el.getAttribute('data-key');
        if (directKey) item = take(function (it) { return it.key === directKey; });
        if (!item && link.variant) item = take(function (it) { return String(it.variant_id) === String(link.variant); });
        if (!item && link.handle) item = take(function (it) { return it.handle === link.handle; });
        if (!item && link.title) item = take(function (it) { return it.product_title === link.title || it.title === link.title; });
        return { el: el, item: item, link: link };
      });
    }

    function build(el, item, plan) {
      var panel = el.querySelector('.bb-cart-engraving-slot') || el.querySelector('.bb-native-cart-item__content') || el;
      var host = panel.querySelector('.bb-engrave');
      if (host && host.dataset.key === item.key) return;
      if (host) host.remove();
      var draft = drafts.get(item.key) || { type: '', size: '', length: '', text: '', open: false };
      drafts.set(item.key, draft);
      var minPrice = Math.min.apply(null, plan.types.map(price));

      host = document.createElement('div');
      host.className = 'bb-engrave';
      host.dataset.key = item.key;

      var toggle = document.createElement('button');
      toggle.type = 'button';
      toggle.className = 'bb-engrave__toggle';
      toggle.textContent = COPY.toggle + ' · ' + COPY.from + ' ' + money(minPrice);
      toggle.setAttribute('aria-expanded', String(draft.open));
      host.appendChild(toggle);

      var form = document.createElement('form');
      form.className = 'bb-engrave__form';
      form.hidden = !draft.open;
      form.noValidate = true;
      host.appendChild(form);

      var uid = 'bb-engrave-' + item.key.replace(/[^a-z0-9]/gi, '');
      var fields = {};

      function radioGroup(name, legend, values, current) {
        var fs = document.createElement('fieldset');
        var lg = document.createElement('legend');
        lg.textContent = legend;
        fs.appendChild(lg);
        var wrap = document.createElement('div');
        wrap.className = 'bb-engrave__choices';
        values.forEach(function (v, i) {
          var lab = document.createElement('label');
          lab.className = 'bb-engrave__choice';
          var input = document.createElement('input');
          input.type = 'radio';
          input.name = uid + '-' + name;
          input.value = v.value;
          input.checked = current ? current === v.value : i === 0;
          var span = document.createElement('span');
          span.textContent = v.value;
          var p = price(v);
          if (p > 0) {
            var small = document.createElement('small');
            small.textContent = '+' + money(p);
            span.appendChild(small);
          }
          lab.appendChild(input);
          lab.appendChild(span);
          wrap.appendChild(lab);
        });
        fs.appendChild(wrap);
        form.appendChild(fs);
        fields[name] = { fieldset: fs, values: values };
        return fs;
      }

      radioGroup('type', COPY.typeLegend, plan.types, draft.type);
      plan.radios.forEach(function (o, idx) {
        var fs = radioGroup('r' + idx, o.label_product, o.option_values || [], draft['r' + idx]);
        fs.dataset.option = o.label_product;
        fields['r' + idx].option = o;
      });

      var textLabel = document.createElement('label');
      textLabel.className = 'bb-engrave__label';
      textLabel.setAttribute('for', uid + '-text');
      textLabel.textContent = COPY.textLabel;
      form.appendChild(textLabel);
      var textarea = document.createElement('textarea');
      textarea.id = uid + '-text';
      textarea.name = 'text';
      textarea.rows = 2;
      textarea.maxLength = 200;
      textarea.value = draft.text || '';
      textarea.setAttribute('aria-describedby', uid + '-hint');
      form.appendChild(textarea);
      var hint = document.createElement('p');
      hint.className = 'bb-engrave__hint';
      hint.id = uid + '-hint';
      hint.textContent = COPY.textHint;
      form.appendChild(hint);

      var error = document.createElement('p');
      error.className = 'bb-engrave__error';
      error.setAttribute('role', 'alert');
      error.hidden = true;
      form.appendChild(error);

      var actions = document.createElement('div');
      actions.className = 'bb-engrave__actions';
      var total = document.createElement('span');
      total.className = 'bb-engrave__total';
      total.setAttribute('aria-live', 'polite');
      var right = document.createElement('div');
      var cancel = document.createElement('button');
      cancel.type = 'button';
      cancel.className = 'bb-engrave__cancel';
      cancel.textContent = COPY.cancel;
      var submit = document.createElement('button');
      submit.type = 'submit';
      submit.className = 'bb-engrave__submit';
      submit.textContent = COPY.submit;
      right.appendChild(cancel);
      right.appendChild(document.createTextNode(' '));
      right.appendChild(submit);
      actions.appendChild(total);
      actions.appendChild(right);
      form.appendChild(actions);

      function selection() {
        var out = { type: null, extras: [] };
        var t = form.querySelector('input[name="' + uid + '-type"]:checked');
        out.type = t ? plan.types.find(function (v) { return v.value === t.value; }) : null;
        Object.keys(fields).forEach(function (name) {
          if (name === 'type') return;
          var f = fields[name];
          var applies = out.type && conditionMet(f.option, out.type.value, plan.typeOpt);
          f.fieldset.hidden = !applies;
          if (!applies) return;
          var chosen = form.querySelector('input[name="' + uid + '-' + name + '"]:checked');
          var v = chosen ? f.values.find(function (x) { return x.value === chosen.value; }) : defaultValue(f.option);
          if (v) out.extras.push({ option: f.option, value: v });
        });
        return out;
      }

      function refresh() {
        var sel = selection();
        var sum = (sel.type ? price(sel.type) : 0) + sel.extras.reduce(function (a, e) { return a + price(e.value); }, 0);
        total.textContent = COPY.adds + ' ' + money(sum);
        draft.type = sel.type ? sel.type.value : '';
        Object.keys(fields).forEach(function (name) {
          var chosen = form.querySelector('input[name="' + uid + '-' + name + '"]:checked');
          draft[name] = chosen ? chosen.value : '';
        });
        draft.text = textarea.value;
        return { sel: sel, sum: sum };
      }

      form.addEventListener('change', refresh);
      textarea.addEventListener('input', function () { draft.text = textarea.value; error.hidden = true; });
      toggle.addEventListener('click', function () {
        draft.open = form.hidden;
        form.hidden = !draft.open;
        toggle.setAttribute('aria-expanded', String(draft.open));
        if (draft.open) {
          refresh();
          var first = form.querySelector('input[type="radio"]');
          if (first) first.focus();
        }
      });
      cancel.addEventListener('click', function () {
        draft.open = false;
        form.hidden = true;
        toggle.setAttribute('aria-expanded', 'false');
        toggle.focus();
      });
      form.addEventListener('submit', function (event) {
        event.preventDefault();
        if (busy) return;
        var state = refresh();
        var text = textarea.value.trim();
        if (!state.sel.type) return;
        if (!text) {
          error.textContent = COPY.needText;
          error.hidden = false;
          textarea.focus();
          return;
        }
        busy = true;
        submit.disabled = true;
        submit.textContent = COPY.adding;
        apply(item, plan, state.sel, text).then(function (ok) {
          busy = false;
          if (ok) {
            drafts.delete(item.key);
            host.remove();
            cartCache = null;
            document.dispatchEvent(new CustomEvent('cart:build'));
            schedule();
          } else {
            submit.disabled = false;
            submit.textContent = COPY.submit;
            error.textContent = COPY.failed;
            error.hidden = false;
          }
        });
      });

      refresh();
      panel.insertBefore(host, panel.firstChild);
    }

    /* Write the same properties Aris writes from the product page, and lift
       its hidden add-on total by the engraving price so the line reprices. */
    function apply(item, plan, sel, text) {
      return readCart(true).then(function (cart) {
        var current = cart && (cart.items || []).find(function (line) { return line.key === item.key; });
        if (!current || hasEngraving(current)) return false;
        return writeEngraving(current, plan, sel, text);
      });
    }

    function writeEngraving(item, plan, sel, text) {
      var props = Object.assign({}, item.properties || {});
      var list = [];
      try { list = JSON.parse(props._apo_options || '[]'); } catch (e) { list = []; }
      if (!Array.isArray(list)) list = [];
      var addons = 0;
      list = list.filter(function (e) {
        if (e && e.name === '_apo_addons') { addons = parseFloat(e.value) || 0; return false; }
        return true;
      });
      function setEntry(name, value) {
        var hit = list.find(function (e) { return e && e.name === name; });
        if (hit) hit.value = value; else list.push({ name: name, value: value });
        props[name] = value;
      }
      var added = price(sel.type);
      setEntry(plan.typeOpt.label_product, sel.type.value);
      sel.extras.forEach(function (e) {
        added += price(e.value);
        setEntry(e.option.label_product, e.value.value);
      });
      setEntry(plan.text.label_product, text);
      list.push({ name: '_apo_addons', value: String(Math.round((addons + added) * 100) / 100) });
      props._apo_options = JSON.stringify(list);

      var root = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(root + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, properties: props })
      }).then(function (r) { return r.ok; }).catch(function () { return false; });
    }

    function update() {
      frame = null;
      if (!lineElements().length) return;
      readCart().then(function (cart) {
        if (!cart) return;
        return loadOptionSets(cart).then(function () {
          matchLines(cart).forEach(function (pair) {
            var stale = pair.el.querySelector('.bb-engrave');
            if (!pair.item || hasEngraving(pair.item)) { if (stale) stale.remove(); return; }
            var plan = engravingPlan(pair.item);
            if (!plan) { if (stale) stale.remove(); return; }
            build(pair.el, pair.item, plan);
          });
        });
      });
    }

    function schedule() {
      if (frame !== null) return;
      frame = requestAnimationFrame(update);
    }

    /* Run bbCartEngraving.diagnose() in the console to see why a line does or
       does not get the offer. */
    function diagnose() {
      var sets = optionSets();
      var lines = lineElements();
      var report = { optionSets: sets.length, drawer: !!document.querySelector('.site-header__cart'), drawerLines: lines.length, offers: document.querySelectorAll('.site-header__cart .bb-engrave').length, lines: [] };
      return readCart(true).then(function (cart) {
        report.cartItems = cart ? (cart.items || []).length : 'cart.js failed';
        if (!cart) { console.table([report]); return report; }
        matchLines(cart).forEach(function (pair) {
          var row = { link: JSON.stringify(pair.link), matched: !!pair.item };
          if (pair.item) {
            row.product = pair.item.product_title;
            row.engraved = hasEngraving(pair.item);
            var plan = engravingPlan(pair.item);
            row.optionSet = plan ? plan.set.name : 'none applies';
            row.types = plan ? plan.types.map(function (v) { return v.value; }).join(', ') : '';
          }
          report.lines.push(row);
        });
        console.log('[bb-cart-engraving]', report);
        if (report.lines.length) console.table(report.lines);
        return report;
      });
    }
    window.bbCartEngraving = { diagnose: diagnose, refresh: function () { cartCache = null; schedule(); } };

    /* Any cart mutation invalidates the cached cart. */
    var cartMutation = /\/cart\/(add|change|update|clear)(\.js|\.json)?(\?|$)/;
    var originalFetch = window.fetch;
    window.fetch = function () {
      var result = originalFetch.apply(this, arguments);
      try {
        var request = arguments[0];
        var url = (request && request.url) || request || '';
        if (cartMutation.test(String(url))) result.then(function () { cartCache = null; schedule(); }, function () {});
      } catch (e) {}
      return result;
    };
    document.addEventListener('cart:updated', function () { cartCache = null; schedule(); });
    document.addEventListener('ajaxProduct:added', function () { cartCache = null; schedule(); });
    document.addEventListener('cart:build', function () { cartCache = null; schedule(); });

    new MutationObserver(function (records) {
      for (var i = 0; i < records.length; i++) {
        var t = records[i].target;
        if (t && t.closest && t.closest('.bb-engrave')) continue;
        schedule();
        return;
      }
    }).observe(document.documentElement, { childList: true, subtree: true });
    schedule();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-homepage-card-actions"] && !Shopify.designMode) return;
  try {
    (() => {
    const configElement = document.getElementById('BBHomepageCardActions');
    const dialog = document.getElementById('BBQuickView');
    const main = document.getElementById('MainContent');
    if (!configElement || !dialog || !main || configElement.dataset.initialized) return;
    configElement.dataset.initialized = 'true';
    const config = JSON.parse(configElement.textContent);
    const desktop = matchMedia('(min-width: 769px) and (hover: hover) and (pointer: fine)');
    const content = dialog.querySelector('[data-bb-qv-content]');
    const cache = new Map();
    const viewed = new Set();
    let trigger;
    let request;
    let requestNumber = 0;
    let activeView;
    let historyPending = false;
    let privacyPromise;

    function enhance(root) {
      const enabled = desktop.matches && typeof dialog.showModal === 'function';
      const buttons = root.matches?.('[data-bb-quickview]') ? [root] : root.querySelectorAll('[data-bb-quickview]');
      buttons.forEach((button) => {
        button.hidden = !enabled;
        button.closest('[data-bb-card-actions]')?.classList.toggle('bb-card-has-quickview', enabled);
        button.setAttribute('aria-haspopup', 'dialog');
        button.setAttribute('aria-controls', 'BBQuickView');
        if (!button.hasAttribute('aria-expanded')) button.setAttribute('aria-expanded', 'false');
      });
    }

    function privacy() {
      if (window.Shopify?.customerPrivacy) return Promise.resolve(window.Shopify.customerPrivacy);
      if (!privacyPromise) privacyPromise = new Promise((resolve) => {
        if (!window.Shopify?.loadFeatures) return resolve(null);
        window.Shopify.loadFeatures([{ name: 'consent-tracking-api', version: '0.1' }], (error) => resolve(error ? null : window.Shopify.customerPrivacy));
      });
      return privacyPromise;
    }

    async function publish(name, data) {
      if (!config.trackingEnabled) return;
      const consent = await privacy();
      if (!consent?.analyticsProcessingAllowed()) return;
      const payload = { ...data, source: config.source, collection: config.collection, device: desktop.matches ? 'desktop' : 'mobile', feature_version: 'quick_view_v2' };
      try {
        window.Shopify?.analytics?.publish(`bb:${name}`, payload);
        if (Array.isArray(window.dataLayer)) window.dataLayer.push({ event: `bb_${name}`, ...payload });
      } catch {}
    }

    async function trackView(view) {
      if (!config.trackingEnabled || !view || !dialog.open || activeView !== view) return;
      const consent = await privacy();
      if (!dialog.open || activeView !== view) return;
      if (consent?.analyticsProcessingAllowed() && !view.analyticsSent) {
        view.analyticsSent = true;
        publish('quick_view_open', { product_id: String(view.item.ProductID), product_url: view.item.URL });
      }
      if (!consent?.marketingAllowed() || !consent?.analyticsProcessingAllowed() || viewed.has(view.item.ProductID)) return;
      if (!document.querySelector('script[src*="static.klaviyo.com/onsite/"]')) return;
      viewed.add(view.item.ProductID);
      const item = { ...view.item, ProductName: view.item.Name, QuickView: true, Source: config.source, Collection: config.collection, Device: 'desktop' };
      window._learnq = window._learnq || [];
      window._learnq.push(['track', 'Viewed Product', item]);
      window._learnq.push(['trackViewedItem', { Title: item.Name, ItemId: item.ProductID, Categories: item.Categories, ImageUrl: item.ImageURL, Url: item.URL, Metadata: { Brand: item.Brand, Price: item.Price, Value: item.Value, CompareAtPrice: item.CompareAtPrice } }]);
    }

    function addSpecs(product) {
      const description = product.querySelector('[data-bb-description]');
      const specs = product.querySelector('.bb-qv-specs');
      if (!description || !specs) return;
      const labels = new Set([...specs.querySelectorAll('dt')].map((x) => x.textContent.toLowerCase()));
      const allowed = /^(overall length|total length|blade length|blade material|steel(?: type)?|hardness|tang|construction|weight|handle(?: material)?)\s*:\s*(.+)$/i;
      for (const node of description.content.querySelectorAll('p, li, tr')) {
        const text = node.textContent.replace(/\s+/g, ' ').trim();
        const match = text.match(allowed);
        if (!match || match[2].length > 180 || labels.has(match[1].toLowerCase())) continue;
        if (specs.children.length >= 6) break;
        const row = document.createElement('div');
        const label = document.createElement('dt');
        const value = document.createElement('dd');
        label.textContent = match[1];
        value.textContent = match[2];
        row.append(label, value);
        specs.append(row);
        labels.add(match[1].toLowerCase());
      }
      description.remove();
    }

    function status(message, url) {
      const paragraph = document.createElement('p');
      paragraph.setAttribute('role', 'status');
      paragraph.textContent = message;
      content.replaceChildren(paragraph);
      if (url) {
        const link = document.createElement('a');
        link.href = url;
        link.textContent = config.fullDetails;
        link.className = 'bb-qv-details';
        content.append(link);
      }
    }

    function close(fromHistory = false) {
      requestNumber += 1;
      request?.abort();
      activeView = null;
      content.removeAttribute('aria-busy');
      if (dialog.open) dialog.close();
      document.documentElement.classList.remove('bb-qv-open');
      trigger?.setAttribute('aria-expanded', 'false');
      trigger?.focus({ preventScroll: true });
      if (!fromHistory && history.state?.bbQuickView) {
        historyPending = true;
        history.back();
      }
    }

    async function open(button) {
      if (!desktop.matches || button.hidden || typeof dialog.showModal !== 'function') return;
      if (historyPending) return;
      const card = button.closest('[data-bb-card-actions]');
      if (!card?.dataset.productUrl) return;
      const productUrl = new URL(card.dataset.productUrl, location.origin);
      trigger = button;
      const token = ++requestNumber;
      request?.abort();
      request = new AbortController();
      const url = new URL(productUrl);
      const cacheKey = url.pathname;
      url.searchParams.set('section_id', 'bb-quick-view');
      status(config.loading);
      content.setAttribute('aria-busy', 'true');
      dialog.removeAttribute('aria-labelledby');
      dialog.showModal();
      document.documentElement.classList.add('bb-qv-open');
      button.setAttribute('aria-expanded', 'true');
      history.pushState({ ...history.state, bbQuickView: true }, '', location.href);
      try {
        let markup = cache.get(cacheKey);
        if (!markup) {
          const response = await fetch(url, { signal: request.signal, credentials: 'same-origin' });
          if (!response.ok) throw new Error('Quick view unavailable');
          markup = await response.text();
          cache.set(cacheKey, markup);
        }
        if (token !== requestNumber || !dialog.open || !desktop.matches) return;
        const documentHTML = new DOMParser().parseFromString(markup, 'text/html');
        const product = documentHTML.querySelector('[data-bb-qv-product]');
        if (!product || product.dataset.productId !== card.dataset.productId) throw new Error('Product mismatch');
        if (product.dataset.bbCardPolicy === 'builder') {
          content.removeAttribute('aria-busy');
          status(config.error, productUrl.href);
          return;
        }
        const item = JSON.parse(product.querySelector('[data-bb-qv-tracking]').textContent);
        product.querySelectorAll('script').forEach((script) => script.remove());
        addSpecs(product);
        content.replaceChildren(product);
        content.removeAttribute('aria-busy');
        dialog.setAttribute('aria-labelledby', 'BBQuickViewProductTitle');
        activeView = { item };
        trackView(activeView);
      } catch (error) {
        if (error.name === 'AbortError' || token !== requestNumber || !dialog.open) return;
        cache.delete(cacheKey);
        content.removeAttribute('aria-busy');
        status(config.error, productUrl.href);
      }
    }

    main.addEventListener('click', (event) => {
      const button = event.target.closest('[data-bb-quickview]');
      if (!button || event.button !== 0) return;
      event.preventDefault();
      open(button);
    });
    dialog.querySelector('[data-bb-qv-close]').addEventListener('click', () => close());
    dialog.addEventListener('cancel', (event) => { event.preventDefault(); close(); });
    dialog.addEventListener('click', (event) => {
      if (event.target === dialog) {
        const bounds = dialog.getBoundingClientRect();
        if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) close();
      }
      const photo = event.target.closest('[data-bb-qv-photo]');
      if (photo) {
        const image = content.querySelector('.bb-qv-main-image');
        image.src = photo.dataset.imageSrc;
        image.removeAttribute('srcset');
        image.alt = photo.dataset.imageAlt;
        content.querySelectorAll('[data-bb-qv-photo]').forEach((button) => button.setAttribute('aria-pressed', String(button === photo)));
      }
      const details = event.target.closest('[data-bb-full-details], .bb-qv-choose');
      if (details && activeView) {
        publish('quick_view_details', { product_id: String(activeView.item.ProductID) });
        if (history.state?.bbQuickView) {
          const state = { ...history.state };
          delete state.bbQuickView;
          history.replaceState(state, '', location.href);
        }
      }
    });
    window.addEventListener('popstate', (event) => {
      const returningToCard = historyPending || dialog.open;
      if (returningToCard || history.state?.bbQuickView) event.stopImmediatePropagation();
      historyPending = false;
      if (dialog.open) close(true);
      if (history.state?.bbQuickView) {
        const state = { ...history.state };
        delete state.bbQuickView;
        history.replaceState(state, '', location.href);
      }
      if (returningToCard) requestAnimationFrame(() => { if (trigger?.isConnected) trigger.focus({ preventScroll: true }); });
    }, { capture: true });
    window.addEventListener('pageshow', () => { if (dialog.open) close(true); });
    desktop.addEventListener('change', () => {
      if (!desktop.matches && dialog.open) close();
      enhance(main);
    });
    document.addEventListener('visitorConsentCollected', () => trackView(activeView));
    document.addEventListener('ajaxProduct:added', async (event) => {
      const button = event.detail?.addToCartBtn;
      if (!(button instanceof Element)) return;
      const fromCard = button.closest('[data-bb-card-actions]');
      const fromPopup = button.closest('#BBQuickView');
      if (!fromCard && !fromPopup) return;
      const productId = fromCard?.dataset.productId || activeView?.item.ProductID;
      publish('card_add_to_cart', { product_id: String(productId), placement: fromPopup ? 'quick_view' : 'card' });
      if (fromPopup) close();
      if (typeof window.fetchCartDynamatic !== 'function') return;
      try {
        await window.fetchCartDynamatic();
        await new Promise((resolve) => requestAnimationFrame(() => requestAnimationFrame(resolve)));
        const drawer = document.querySelector('.dyn-main-cart-slide');
        const bounds = drawer?.getBoundingClientRect();
        const isOpen = document.body.classList.contains('dyn-overflow') || drawer?.style.transform === 'translateX(0px)' || (bounds && bounds.width > 0 && bounds.left < innerWidth && bounds.right > 0);
        if (!isOpen) document.getElementById('HeaderCartTrigger')?.click();
      } catch { window.location.assign(`${window.Shopify.routes.root}cart`); }
    });
    enhance(main);
    new MutationObserver((records) => {
      for (const record of records) for (const node of record.addedNodes) if (node instanceof Element) enhance(node);
    }).observe(main, { childList: true, subtree: true });
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-native-cart"] && !Shopify.designMode) return;
  try {
    (function () {
    if (window.__bbNativeCart) return;
    window.__bbNativeCart = true;

    var threshold = 25000;
    var pending = null;

    function drawer() {
      return document.querySelector('.site-header__cart');
    }

    function money(cents, currency) {
      try {
        return new Intl.NumberFormat(document.documentElement.lang || 'en-US', {
          style: 'currency',
          currency: currency || 'USD'
        }).format(cents / 100);
      } catch (error) {
        return '$' + (cents / 100).toFixed(2);
      }
    }

    function explicitDiscount(cart) {
      var total = 0;
      var cartApps = Array.isArray(cart.cart_level_discount_applications) ? cart.cart_level_discount_applications : [];
      cartApps.forEach(function (app) {
        if (app && app.type === 'discount_code') total += Number(app.total_allocated_amount) || 0;
      });
      (cart.items || []).forEach(function (item) {
        (item.line_level_discount_allocations || []).forEach(function (allocation) {
          if (allocation.discount_application && allocation.discount_application.type === 'discount_code') {
            total += Number(allocation.amount) || 0;
          }
        });
      });
      return total;
    }

    function updateMixedShipping(root) {
      var states = Array.from(root.querySelectorAll('.bb-native-cart-item')).map(function (item) {
        return item.dataset.bbCartShippingState;
      });
      var mixed = states.indexOf('ready') !== -1 && states.some(function (state) {
        return state === 'custom' || state === 'custom_extended';
      });
      var row = root.querySelector('[data-bb-mixed-shipping]');
      if (row) row.hidden = !mixed;
    }

    function normalizedProductId(value) {
      var match = String(value || '').match(/\d+$/);
      return match ? match[0] : String(value || '');
    }

    function syncRecommendationsFromDom(root) {
      if (!root) return;

      var productIds = new Set(
        Array.from(root.querySelectorAll('.bb-native-cart-item[data-product-id]')).map(function (item) {
          return normalizedProductId(item.dataset.productId);
        })
      );

      var visible = 0;
      root.querySelectorAll('.bb-native-cart-reco__item[data-product-id]').forEach(function (row) {
        var inCart = productIds.has(normalizedProductId(row.dataset.productId));
        row.dataset.bbInCart = inCart ? 'true' : 'false';
        row.hidden = inCart;
        if (!inCart) visible += 1;
      });

      var block = root.querySelector('.bb-native-cart-reco');
      if (block) block.hidden = visible === 0;
    }

    function render(cart) {
      var root = drawer();
      if (!root || !cart) return;

      root.querySelectorAll('[data-bb-cart-count]').forEach(function (node) {
        node.textContent = String(cart.item_count || 0);
      });

      var remaining = Math.max(0, threshold - (Number(cart.total_price) || 0));
      var shipping = root.querySelector('[data-bb-free-shipping]');
      var copy = root.querySelector('[data-bb-free-shipping-copy]');
      if (shipping) {
        shipping.style.setProperty('--bb-cart-progress', Math.min(100, ((Number(cart.total_price) || 0) / threshold) * 100) + '%');
      }
      if (copy) {
        copy.textContent = remaining <= 0
          ? 'You’ve unlocked FREE U.S. shipping.'
          : "You're only " + money(remaining, cart.currency) + ' away from FREE U.S. shipping!';
      }

      root.querySelectorAll('[data-bb-subtotal-label]').forEach(function (row) {
        var label = row.querySelector('[data-bb-cart-count-label]');
        if (label) label.textContent = Number(cart.item_count) === 1 ? row.dataset.one : row.dataset.many;
      });

      var discount = explicitDiscount(cart);
      var savings = root.querySelector('[data-bb-cart-savings]');
      if (savings) {
        savings.hidden = discount <= 0;
        savings.textContent = discount > 0 ? 'You save ' + money(discount, cart.currency) + '.' : '';
      }

      var productIds = new Set((cart.items || []).map(function (item) {
        return normalizedProductId(item.product_id);
      }));

      var visibleRecommendations = 0;
      root.querySelectorAll('.bb-native-cart-reco__item[data-product-id]').forEach(function (row) {
        var inCart = productIds.has(normalizedProductId(row.dataset.productId));
        row.hidden = inCart;
        if (!inCart) visibleRecommendations += 1;
      });

      var recommendationsBlock = root.querySelector('.bb-native-cart-reco');
      if (recommendationsBlock) recommendationsBlock.hidden = visibleRecommendations === 0;

      syncRecommendationsFromDom(root);
      updateMixedShipping(root);
    }

    function cleanupLegacyCartOfferCodes(cart) {
      if (!cart || !Array.isArray(cart.discount_codes)) return Promise.resolve(cart);

      var legacy = new Set(['BBCART10', 'BBCARTSTAND10', 'BBCARTCLEAN10', 'BBCARTSHARP10']);
      var remaining = [];
      var foundLegacy = false;

      cart.discount_codes.forEach(function (entry) {
        var code = String(typeof entry === 'string' ? entry : entry && entry.code || '').trim();
        if (!code) return;
        if (legacy.has(code.toUpperCase())) foundLegacy = true;
        else remaining.push(code);
      });

      if (!foundLegacy) return Promise.resolve(cart);

      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
      return fetch(rootPath + 'cart/update.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          discount: remaining.join(','),
          sections: 'cart-ajax'
        })
      })
        .then(function (response) {
          if (!response.ok) return cart;
          return response.json();
        })
        .then(function (state) {
          var cartElement = document.querySelector('header-cart-drawer.bb-native-cart');
          var markup = state && state.sections && state.sections['cart-ajax'];
          if (cartElement && cartElement.cartForm && markup) cartElement.cartForm.cartMarkup(markup);
          return state || cart;
        })
        .catch(function () { return cart; });
    }

    function refresh(delay) {
      window.clearTimeout(refresh.timer);
      refresh.timer = window.setTimeout(function () {
        if (pending) return;
        var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        pending = fetch(rootPath + 'cart.js', {
          headers: { Accept: 'application/json' },
          cache: 'no-store'
        })
          .then(function (response) { return response.ok ? response.json() : null; })
          .then(cleanupLegacyCartOfferCodes)
          .then(render)
          .catch(function () {})
          .then(function () { pending = null; });
      }, delay || 0);
    }

    document.addEventListener('click', function (event) {
      var target = event.target;
      if (!target || !target.closest) return;

      var close = target.closest('[data-bb-native-cart-close]');
      if (close) {
        event.preventDefault();
        document.documentElement.classList.remove('bb-native-cart-open');
        document.dispatchEvent(new CustomEvent('cart:close'));
        return;
      }

      var recommendation = target.closest('[data-bb-reco-add]');
      if (recommendation) {
        event.preventDefault();
        var variantId = recommendation.getAttribute('data-bb-reco-add');
        if (!variantId || recommendation.getAttribute('aria-busy') === 'true') return;
        recommendation.setAttribute('aria-busy', 'true');

        var addRoot = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
        fetch(addRoot + 'cart/add.js', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            Accept: 'application/json'
          },
          body: JSON.stringify({
            items: [{ id: Number(variantId), quantity: 1 }],
            sections: 'cart-ajax'
          })
        })
          .then(function (response) {
            if (!response.ok) throw response;
            return response.json();
          })
          .then(function (state) {
            var recommendationRow = recommendation.closest('.bb-native-cart-reco__item');
            if (recommendationRow) {
              recommendationRow.dataset.bbInCart = 'true';
              recommendationRow.hidden = true;
            }

            document.dispatchEvent(
              new CustomEvent('ajaxProduct:added', {
                bubbles: true,
                detail: {
                  product: state,
                  addToCartBtn: recommendation,
                  preventCartOpen: true
                }
              })
            );
            render(state);
            refresh(60);
          })
          .catch(function () {})
          .then(function () {
            recommendation.removeAttribute('aria-busy');
          });
        return;
      }

      var remove = target.closest('.bb-native-cart-item__remove');
      if (!remove) return;

      event.preventDefault();

      var item = remove.closest('.bb-native-cart-item');
      var key = item && item.getAttribute('data-key');
      if (!key || remove.getAttribute('aria-busy') === 'true') return;

      remove.setAttribute('aria-busy', 'true');
      var rootPath = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';

      fetch(rootPath + 'cart/change.js', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Accept: 'application/json'
        },
        body: JSON.stringify({
          id: key,
          quantity: 0,
          sections: 'cart-ajax'
        })
      })
        .then(function (response) {
          if (!response.ok) throw response;
          return response.json();
        })
        .then(function (state) {
          var cartElement = document.querySelector('header-cart-drawer.bb-native-cart');
          var markup = state && state.sections && state.sections['cart-ajax'];

          if (cartElement && cartElement.cartForm && markup) {
            cartElement.cartForm.cartMarkup(markup);
          } else {
            document.dispatchEvent(new CustomEvent('cart:build'));
          }

          document.dispatchEvent(
            new CustomEvent('cart:updated', {
              detail: { cart: state }
            })
          );

          render(state);
        })
        .catch(function () {
          remove.removeAttribute('aria-busy');
        });
    });

    document.addEventListener('ajaxProduct:added', function () { refresh(80); });
    document.addEventListener('cart:updated', function () { refresh(80); });
    document.addEventListener('cart:build', function () { refresh(180); });
    document.addEventListener('bb:cart-refreshed', function () { refresh(0); });
    document.addEventListener('headerDrawer:opened', function (event) {
      if (!event.target || !event.target.classList || !event.target.classList.contains('site-header__cart')) return;
      document.documentElement.classList.add('bb-native-cart-open');
      var root = drawer();
      var scroll = root && root.querySelector('.bb-native-cart__scroll');
      if (scroll) scroll.scrollTop = 0;
      refresh(40);
    });
    document.addEventListener('headerDrawer:closed', function (event) {
      if (!event.target || !event.target.classList || !event.target.classList.contains('site-header__cart')) return;
      document.documentElement.classList.remove('bb-native-cart-open');
    });

    new MutationObserver(function () {
      var root = drawer();
      if (!root) return;
      syncRecommendationsFromDom(root);
      updateMixedShipping(root);
    }).observe(document.documentElement, { childList: true, subtree: true });

    refresh(0);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-product-review-tools"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-product-review-tools')) {
    class BBProductReviewTools extends HTMLElement {
      connectedCallback() {
        this.controller = new AbortController();
        this.observe = new MutationObserver(() => this.schedule());
        this.observe.observe(document.getElementById('MainContent') || document.body, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
        this.sync();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observe?.disconnect();
        cancelAnimationFrame(this.frame);
        this.toolbar?.remove();
      }

      schedule() {
        cancelAnimationFrame(this.frame);
        this.frame = requestAnimationFrame(() => this.sync());
      }

      sortControl() {
        return [...(this.widget?.querySelectorAll('select.jdgm-sort-dropdown') || [])].find((select) => [...select.options].some((option) => option.value === 'pictures-first'));
      }

      sync() {
        if (!this.widget) {
          this.widget = [...document.querySelectorAll('.jdgm-review-widget')].find((widget) => (widget.dataset.productId || widget.dataset.id) === this.dataset.productId && widget.dataset.shopReviews !== 'true');
          if (!this.widget) return;
          this.observe.disconnect();
          this.observe.observe(this.widget, { childList: true, subtree: true, attributes: true, attributeFilter: ['class'] });
          this.widget.addEventListener('change', () => this.schedule(), { signal: this.controller.signal });
        }
        const select = this.sortControl();
        const header = this.widget.querySelector('.jdgm-rev-widg__header');
        if (!select || !header || !this.widget.classList.contains('jdgm--done-setup-widget')) return;
        if (!this.toolbar?.isConnected) {
          if (this.widget.querySelector('[data-bb-review-tools]')) return;
          this.toolbar = this.querySelector('template').content.firstElementChild.cloneNode(true);
          this.toolbar.addEventListener('click', (event) => {
            const button = event.target.closest('button[data-bb-review-sort]');
            const control = this.sortControl();
            if (!button || !control) return;
            control.value = button.dataset.bbReviewSort;
            control.dispatchEvent(new Event('change', { bubbles: true }));
            this.schedule();
          }, { signal: this.controller.signal });
          header.append(this.toolbar);
        }
        this.toolbar.querySelectorAll('button').forEach((button) => {
          button.hidden = ![...select.options].some((option) => option.value === button.dataset.bbReviewSort);
          button.setAttribute('aria-pressed', String(select.value === button.dataset.bbReviewSort));
        });
      }
    }
    customElements.define('bb-product-review-tools', BBProductReviewTools);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-search-recovery"] && !Shopify.designMode) return;
  try {
    (() => {
    const normalize = (value) => String(value).normalize('NFKC').toLocaleLowerCase().trim();
    const words = (value) => normalize(value).match(/\p{L}+/gu) || [];
    const ignored = new Set(['and', 'the', 'for', 'with', 'from', 'into', 'your', 'this', 'that', 'are', 'buy', 'get', 'need', 'want', 'looking']);
    const systemType = /avis|shopstorm|deleted|service|^\d|_/i;

    function distance(a, b) {
      const rows = Array.from({ length: a.length + 1 }, (_, i) => [i]);
      for (let j = 0; j <= b.length; j++) rows[0][j] = j;
      for (let i = 1; i <= a.length; i++) {
        for (let j = 1; j <= b.length; j++) {
          rows[i][j] = Math.min(rows[i - 1][j] + 1, rows[i][j - 1] + 1, rows[i - 1][j - 1] + (a[i - 1] === b[j - 1] ? 0 : 1));
          if (i > 1 && j > 1 && a[i - 1] === b[j - 2] && a[i - 2] === b[j - 1]) rows[i][j] = Math.min(rows[i][j], rows[i - 2][j - 2] + 1);
        }
      }
      return rows[a.length][b.length];
    }

    class BBSearchRecovery extends HTMLElement {
      static queries(query, types) {
        const original = String(query).trim();
        if (original.length < 2 || original.length > 120 || /[:]|"[^"]+"|(?:^|\s)-(?:\p{L}|\d)|\b(?:not|without|except|and|or)\b/iu.test(original)) return [];
        const vocabulary = new Set(types.filter((type) => typeof type === 'string' && !systemType.test(type)).flatMap(words).filter((word) => word.length >= 3 && !ignored.has(word)));
        for (const term of [...vocabulary]) if (term.length > 4 && term.endsWith('s') && !term.endsWith('ss')) vocabulary.add(term.slice(0, -1));
        for (const [singular, plural] of [['knife', 'knives'], ['sword', 'swords'], ['axe', 'axes']]) if (vocabulary.has(singular)) vocabulary.add(plural);
        const tokens = words(original).filter((word) => !ignored.has(word));
        if (!tokens.length || tokens.length > 8 || /\d/.test(original)) return [original];
        const corrected = tokens.map((word) => {
          if (vocabulary.has(word) || word.length < 4 || word.length > 32) return word;
          let best = null;
          let bestDistance = Infinity;
          let tied = false;
          const limit = word.length >= 6 ? 2 : 1;
          for (const candidate of vocabulary) {
            if (Math.abs(word.length - candidate.length) > limit) continue;
            const score = distance(word, candidate);
            if (score > limit || score / Math.max(word.length, candidate.length) > 0.25) continue;
            if (score < bestDistance) { best = candidate; bestDistance = score; tied = false; }
            else if (score === bestDistance && candidate !== best) tied = true;
          }
          return best && !tied ? best : word;
        });
        const candidates = [original];
        const correctedPhrase = corrected.join(' ');
        if (correctedPhrase !== normalize(original)) candidates.push(correctedPhrase);
        const categoryWords = [...new Set(corrected.filter((word) => vocabulary.has(word)))];
        if (categoryWords.length) candidates.push(categoryWords.join(' '));
        if (categoryWords.length > 1) {
          const specific = categoryWords.filter((word) => !['sword', 'swords', 'knife', 'knives', 'custom', 'sets', 'bundle'].includes(word));
          if (specific.length) candidates.push(specific.join(' '));
          for (const term of specific.sort((a, b) => b.length - a.length)) candidates.push(term);
        }
        return [...new Map(candidates.map((value) => [normalize(value), value])).values()].slice(0, 4);
      }

      connectedCallback() {
        if (this.started) return;
        this.started = true;
        this.controller = new AbortController();
        this.load();
      }

      disconnectedCallback() { this.controller?.abort(); this.started = false; }

      async load() {
        const status = this.querySelector('[data-bb-search-status]');
        const current = new URL(window.location.href);
        const filtered = [...current.searchParams.keys()].some((key) => key.startsWith('filter.'));
        if (filtered) {
          const clear = this.querySelector('[data-bb-clear-filters]');
          const url = new URL(this.dataset.searchUrl, window.location.origin);
          url.searchParams.set('q', this.dataset.query);
          for (const key of ['type', 'options[prefix]']) if (current.searchParams.has(key)) url.searchParams.set(key, current.searchParams.get(key));
          clear.href = url.pathname + url.search;
          clear.hidden = false;
          return;
        }
        let types;
        try { types = JSON.parse(this.dataset.types); } catch { types = []; }
        const queries = BBSearchRecovery.queries(this.dataset.query, Array.isArray(types) ? types : []);
        if (!queries.length) return;
        status.textContent = this.dataset.loading;
        try {
          for (const query of queries) {
            const url = new URL(this.dataset.suggestUrl, window.location.origin);
            url.searchParams.set('q', query);
            url.searchParams.set('resources[type]', 'product');
            url.searchParams.set('resources[limit]', '4');
            url.searchParams.set('resources[options][unavailable_products]', 'hide');
            url.searchParams.set('section_id', 'bb-search-suggestions');
            const timeout = setTimeout(() => this.controller.abort(), 5000);
            let response;
            let html;
            try {
              response = await fetch(url.pathname + url.search, { signal: this.controller.signal, credentials: 'same-origin' });
              if (!response.ok) break;
              html = await response.text();
            } finally { clearTimeout(timeout); }
            if (!this.isConnected) return;
            const doc = new DOMParser().parseFromString(html, 'text/html');
            const list = doc.querySelector('[data-bb-suggestion-products]');
            if (!list?.querySelector('[data-bb-suggestion-product]')) continue;
            this.querySelector('[data-bb-product-options]').replaceChildren(document.importNode(list, true));
            this.querySelector('[data-bb-search-context]').textContent = this.dataset.basedOn.replace('%term%', query);
            const more = this.querySelector('[data-bb-see-results]');
            const resultsUrl = new URL(this.dataset.searchUrl, window.location.origin);
            resultsUrl.searchParams.set('q', query);
            resultsUrl.searchParams.set('type', 'product');
            resultsUrl.searchParams.set('options[prefix]', 'last');
            more.href = resultsUrl.pathname + resultsUrl.search;
            more.textContent = this.dataset.seeResults.replace('%term%', query);
            this.querySelector('[data-bb-related]').hidden = false;
            this.querySelector('[data-bb-search-browse]').hidden = true;
            status.textContent = this.dataset.ready;
            return;
          }
          status.textContent = '';
        } catch {
          status.textContent = '';
        }
      }
    }
    if (!customElements.get('bb-search-recovery')) customElements.define('bb-search-recovery', BBSearchRecovery);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["bb-shipping-estimate"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bb-shipping-estimate')) {
    const SIMPLE_STATES = ['variable', 'custom', 'custom_extended'];
    class BBShippingEstimate extends HTMLElement {
      connectedCallback() {
        this.scope = this.closest('block-buy-buttons') || this.parentElement;
        this.controller = new AbortController();
        const options = { signal: this.controller.signal };
        this.scope.addEventListener('change', () => this.update(), options);
        this.scope.addEventListener('input', () => this.update(), options);
        this.eventName = `variant:change:${this.dataset.sectionId}:${this.dataset.productId}`;
        document.addEventListener(this.eventName, (event) => {
          const { html, variant, loading } = event.detail || {};
          if (loading) { this.show('updating'); return; }
          const source = html?.querySelector(`bb-shipping-estimate[data-section-id="${CSS.escape(this.dataset.sectionId)}"][data-product-id="${CSS.escape(this.dataset.productId)}"]`);
          this.dataset.state = !variant ? 'unavailable' : source?.dataset.state || 'variable';
          this.update();
        }, options);
        this.observer = new MutationObserver((records) => {
          if (records.some((record) => !this.contains(record.target))) this.update();
        });
        this.observer.observe(this.scope, { childList: true, subtree: true, attributes: true, attributeFilter: ['checked', 'disabled', 'style', 'class'] });
        this.update();
      }

      disconnectedCallback() {
        this.controller?.abort();
        this.observer?.disconnect();
      }

      selections() {
        return [...this.scope.querySelectorAll('.avpoptions-container__v2 input, .avpoptions-container__v2 select, .avpoptions-container__v2 textarea, [name^="properties["]')]
          .filter((control) => !control.disabled && control.type !== 'hidden' && control.getClientRects().length && (!['checkbox', 'radio'].includes(control.type) || control.checked))
          .map((control) => ({ name: (control.getAttribute('field-name') || control.name || '').replace(/^properties\[|\]$/g, '').trim(), value: control.value.trim() }))
          .filter(({ value }) => value && !/^(none|no|no change|not selected|select(?: an? option)?|-+)$/i.test(value));
      }

      update() {
        const selections = this.selections();
        const fullCustom = selections.some(({ name }) => /^customize (?:your )?(?:sword|knife|ax(?:e)?|spear|armor|chess)\b|full custom(?:ization)?/i.test(name));
        // Engraving is done in house and never changes the estimate.
        let state = this.dataset.state;
        if (!['unavailable', 'digital'].includes(state)) {
          if (['custom', 'custom_extended'].includes(state) || fullCustom) state = this.dataset.customState;
        }
        this.show(state);
        this.scope.querySelectorAll('.apo-tooltip-title, .ap-helptext').forEach((element) => {
          const text = element.textContent;
          const revised = text.replace(/(?:Build time typically ranges from )?4(?:[–-]| to )8 weeks(?: depending on selected options\.)?/gi, this.dataset.customCopy);
          if (revised !== text) element.textContent = revised;
        });
      }

      show(state) {
        const template = this.querySelector(`[data-bb-shipping-message="${state}"]`);
        const target = this.querySelector('[data-bb-shipping-current]');
        if (template && target && target.textContent !== template.content.textContent) target.replaceChildren(template.content.cloneNode(true));
        const variable = SIMPLE_STATES.includes(state);
        const details = this.querySelector('[data-bb-shipping-details]');
        const detailsLabel = variable ? this.dataset.variableDetailsLabel : this.dataset.detailsLabel;
        if (details && details.textContent !== detailsLabel) details.textContent = detailsLabel;
        if (this.dataset.displayState !== state) this.dataset.displayState = state;
        const input = this.querySelector('[data-bb-ship-input]');
        const propertyTemplate = this.querySelector(`[data-bb-ship-property="${state}"]`);
        if (input) {
          const text = propertyTemplate ? propertyTemplate.content.textContent.trim() : '';
          if (input.value !== text) input.value = text;
          input.disabled = !text;
        }
      }
    }
    customElements.define('bb-shipping-estimate', BBShippingEstimate);
  }
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["element.select"] && !Shopify.designMode) return;
  try {
    // Custom element for select button functionality
  class ElementSelect extends HTMLElement {
    constructor() {
      super()
      this.select = null
      this.buttonText = null
      this.button = null
    }

    connectedCallback() {
      // Wait for DOM to be ready
      this.select = this.querySelector('select')
      this.button = this.querySelector('.element-button')

      if (this.select && this.button) {
        this.init()
      }
    }

    init() {
      // Find the button text element within the element.button
      this.buttonText = this.button.querySelector('.element-text') || this.button.querySelector('[data-button-text]')

      // Set initial text
      this.updateButtonText()

      // Add click handler to button to trigger select
      this.button.addEventListener('click', (e) => this.handleButtonClick(e))

      // Add keyboard handler for the select element
      this.select.addEventListener('keydown', (e) => this.handleKeydown(e))

      // Update on change
      this.select.addEventListener('change', () => this.updateButtonText())

      // Update on focus for better UX
      this.select.addEventListener('focus', () => this.handleFocus())
      this.select.addEventListener('blur', () => this.handleBlur())
    }

    handleButtonClick(e) {
      // Prevent default button behavior
      e.preventDefault()
      e.stopPropagation()

      // Trigger the native select
      this.select.focus()
      this.select.click()
    }

    handleKeydown(e) {
      // Handle keyboard navigation for the select
      switch (e.key) {
        case 'Enter':
        case ' ':
          e.preventDefault()
          this.select.click()
          break
        case 'ArrowDown':
        case 'ArrowUp':
          // Let the native select handle arrow key navigation
          break
        default:
          // Let other keys pass through
          break
      }
    }

    updateButtonText() {
      if (!this.buttonText) return

      const selectedOption = this.select.options[this.select.selectedIndex]
      if (selectedOption && selectedOption.value !== '') {
        this.buttonText.textContent = selectedOption.textContent
      } else {
        this.buttonText.textContent = this.select.getAttribute('aria-label') || 'Select an option'
      }
    }

    handleFocus() {
      this.classList.add('element-select__wrapper--focused')
    }

    handleBlur() {
      this.classList.remove('element-select__wrapper--focused')
    }

    disconnectedCallback() {
      // Clean up event listeners
      if (this.button) {
        this.button.removeEventListener('click', (e) => this.handleButtonClick(e))
      }
      if (this.select) {
        this.select.removeEventListener('keydown', (e) => this.handleKeydown(e))
        this.select.removeEventListener('change', () => this.updateButtonText())
        this.select.removeEventListener('focus', () => this.handleFocus())
        this.select.removeEventListener('blur', () => this.handleBlur())
      }
    }
  }

  // Register the custom element
  customElements.define('element-select', ElementSelect)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.customer"] && !Shopify.designMode) return;
  try {
    class FormCustomer extends HTMLElement {
    static emailPattern = /^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/

    connectedCallback() {
      this.controller?.abort()
      const { signal } = (this.controller = new AbortController())

      const form = this.querySelector('form')
      const input = form?.querySelector('input[name="contact[email]"]')
      if (!input) return

      const validate = () => {
        const ok = FormCustomer.emailPattern.test(input.value.trim())
        input.setCustomValidity(ok ? '' : this.dataset.invalidMessage)
      }

      input.addEventListener('input', validate, { signal })
      form.addEventListener(
        'submit',
        (e) => {
          validate()
          if (!form.reportValidity()) e.preventDefault()
        },
        { signal, passive: false }
      )
    }

    disconnectedCallback() {
      this.controller?.abort()
    }
  }

  customElements.define('form-customer', FormCustomer)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product"] && !Shopify.designMode) return;
  try {
    class ProductForm extends HTMLElement {
    constructor() {
      super()
      this.form = this.querySelector('form')
      this.submitButton = this.findSubmitButton()
      this.form.addEventListener('submit', this.onSubmitHandler.bind(this))
    }

    findSubmitButton() {
      // Look for submit button in the form
      const submitButton = this.form.querySelector('button[type="submit"], input[type="submit"]')
      return submitButton
    }

    disableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = true
        this.submitButton.classList.add('product-form__submit-button--pulsing')
      }
    }

    enableSubmitButton() {
      if (this.submitButton) {
        this.submitButton.disabled = false
        this.submitButton.classList.remove('product-form__submit-button--pulsing')
      }
    }

    async onSubmitHandler(evt) {
      evt.preventDefault()

      // Disable submit button and start pulsing
      this.disableSubmitButton()

      // Get cart state before form submission
      let cartBeforeSubmission
      try {
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        cartBeforeSubmission = await cartResponse.json()
      } catch (error) {
        console.error('Failed to get cart state before submission:', error)
        cartBeforeSubmission = null
      }

      const config = {
        method: 'POST',
        headers: {
          'X-Requested-With': 'XMLHttpRequest'
        }
      }

      const formData = new FormData(this.form)

      // Dispatch event allowing subscribers to modify formData
      this.dispatchEvent(
        new CustomEvent('product-form:submit:before', {
          bubbles: true,
          detail: {
            form: formData
          },
          cancelable: true
        })
      )

      // Wait for the next tick to allow async event listeners to complete
      // This ensures all synchronous and microtask listeners have finished
      await new Promise((resolve) => {
        // Use queueMicrotask for better performance than setTimeout
        queueMicrotask(resolve)
      })

      config.body = formData

      // Dispatch event allowing subscribers to handle cart request themselves
      const cartRequestEvent = new CustomEvent('product-form:cart:request', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: formData,
          config: config,
          cartBefore: cartBeforeSubmission,
          resolve: (responseData) => this.resolveCartRequest(responseData),
          reject: (error) => this.rejectCartRequest(error)
        }
      })

      const cartRequestHandled = !this.dispatchEvent(cartRequestEvent)
      let responseData

      try {
        if (cartRequestHandled) {
          // Event was cancelled, meaning a subscriber handled the cart request
          // We need to wait for them to provide the response data
          responseData = await this.waitForCartResponse()
        } else {
          // No subscriber handled it, proceed with default behavior
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, config)
          responseData = await response.json()

          if (!response.ok) {
            throw responseData
          }
        }

        // Get updated cart state after form submission
        const cartResponse = await fetch(`${window.Shopify.routes.root}cart.js`)
        const cartAfterSubmission = await cartResponse.json()

        this.dispatchEvent(
          new CustomEvent('product-form:submit:success', {
            bubbles: true,
            detail: {
              form: formData,
              response: responseData,
              cart: cartAfterSubmission
            }
          })
        )

        // Only fire cart:update if there's a change from this specific submission
        if (this.hasCartChanged(cartBeforeSubmission, cartAfterSubmission)) {
          this.dispatchEvent(
            new CustomEvent('product-form:cart:update', {
              bubbles: true,
              detail: {
                cart: cartAfterSubmission,
                form: formData,
                response: responseData
              }
            })
          )
        }

        // Navigate to cart unless prevented by another event handler
        const cartNavigationEvent = new CustomEvent('product-form:cart:navigate', {
          bubbles: true,
          cancelable: true,
          detail: {
            form: formData,
            response: responseData,
            cart: cartAfterSubmission
          }
        })

        const navigationPrevented = !this.dispatchEvent(cartNavigationEvent)

        if (!navigationPrevented) {
          window.location.href = `${window.Shopify.routes.root}cart`
        }
      } catch (error) {
        this.dispatchEvent(
          new CustomEvent('product-form:submit:error', {
            bubbles: true,
            detail: {
              form: formData,
              cart: cartBeforeSubmission,
              error: error
            }
          })
        )
      } finally {
        // Re-enable submit button and stop pulsing
        this.enableSubmitButton()
      }
    }

    /**
     * Waits for a subscriber to provide cart response data after handling the cart request
     * @returns {Promise<Object>} The cart response data
     */
    waitForCartResponse() {
      return new Promise((resolve, reject) => {
        // Store the resolver for this request
        this._cartRequestResolver = { resolve, reject }

        // Set a timeout to prevent hanging
        const timeout = setTimeout(() => {
          if (this._cartRequestResolver) {
            delete this._cartRequestResolver
            reject(new Error('Cart request timeout - no response received from subscriber'))
          }
        }, 30000) // 30 second timeout

        // Store timeout reference for cleanup
        this._cartRequestResolver.timeout = timeout
      })
    }

    /**
     * Resolves a pending cart request with response data
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Object} responseData - The cart response data
     */
    resolveCartRequest(responseData) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.resolve(responseData)
        delete this._cartRequestResolver
      }
    }

    /**
     * Rejects a pending cart request with an error
     * Called by subscribers who handle the cart request
     * @param {string} requestId - The request ID from the waiting event
     * @param {Error} error - The error that occurred
     */
    rejectCartRequest(error) {
      if (this._cartRequestResolver) {
        clearTimeout(this._cartRequestResolver.timeout)
        this._cartRequestResolver.reject(error)
        delete this._cartRequestResolver
      }
    }

    hasCartChanged(cartBefore, cartAfter) {
      if (!cartBefore || !cartAfter) {
        return true // If we can't compare, assume there's a change
      }

      // Deep comparison using JSON.stringify for simplicity
      // This handles all nested changes automatically
      return JSON.stringify(cartBefore) !== JSON.stringify(cartAfter)
    }
  }

  customElements.define('product-form', ProductForm)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["form.product.messages"] && !Shopify.designMode) return;
  try {
    class ProductFormMessages extends HTMLElement {
    constructor() {
      super()

      // Pull localized error message from data attributes
      this.formId = this.dataset.formId
      this.defaultErrorMessage = this.dataset.error
      this.defaultSuccessMessage = this.dataset.success

      // Create abort controller for event cleanup
      this.abortController = new AbortController()
    }

    connectedCallback() {
      // Cache the template content for better performance
      this.cacheTemplate()
      this.bindEvents()
    }

    disconnectedCallback() {
      // Clean up event listeners when component is removed
      this.abortController.abort()
    }

    cacheTemplate() {
      const template = this.querySelector('template')
      if (template) {
        this.template = template.innerHTML
        this.templateElement = template
      }
    }

    bindEvents() {
      const { signal } = this.abortController

      // Listen for form submission start to clear error messages
      document.addEventListener('product-form:submit:before', this.handleSubmitStart.bind(this), { signal })

      // Listen for form errors
      document.addEventListener('product-form:submit:error', this.handleError.bind(this), { signal })

      // Listen for form success
      document.addEventListener('product-form:submit:success', this.handleSuccess.bind(this), { signal })
    }

    handleSubmitStart(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      this.clearMessages()
    }

    handleSuccess(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      let message = this.defaultSuccessMessage

      const successMessageEvent = new CustomEvent('product-form:message:success', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      // Dispatch the event and check if it was cancelled
      const eventCancelled = !this.dispatchEvent(successMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(successMessageEvent.detail.message)
    }

    handleError(e) {
      if (e.target.form.getAttribute('id') !== this.formId) {
        return
      }

      const error = e.detail.error
      let message = this.defaultErrorMessage

      // Use server response message if available (already localized)
      if (error.description) {
        message = error.description
      } else if (error.message) {
        message = error.message
      }

      const errorMessageEvent = new CustomEvent('product-form:message:error', {
        bubbles: true,
        cancelable: true,
        detail: {
          form: e.target.form,
          response: e.detail.response,
          cart: e.detail.cart,
          message: message
        }
      })

      const eventCancelled = !this.dispatchEvent(errorMessageEvent)

      if (eventCancelled) {
        return
      }

      this.showMessage(errorMessageEvent.detail.message)
    }

    showMessage(message) {
      // Clear existing error messages
      this.clearMessages()
      this.classList.remove('hide')

      // Use cached template content and replace <slot> with the error message
      if (this.template) {
        const messageContent = this.template.replace('<slot></slot>', message)

        // Insert the error message content
        this.innerHTML = messageContent
      }
    }

    clearMessages() {
      this.classList.add('hide')

      // Restore the original template structure using cached template
      if (this.templateElement) {
        this.innerHTML = this.templateElement.outerHTML
      }
    }
  }

  customElements.define('product-form-messages', ProductFormMessages)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.grid"] && !Shopify.designMode) return;
  try {
    class LayoutGrid extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-grid', LayoutGrid)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.stack"] && !Shopify.designMode) return;
  try {
    class LayoutStack extends HTMLElement {
    constructor() {
      super()
    }

    connectedCallback() {
      this.attachShadowRoots(this)
    }

    attachShadowRoots(element) {
      if (this.shadowRoot) {
        return
      }

      element.querySelectorAll('template[shadowrootmode]').forEach((template) => {
        const mode = template.getAttribute('shadowrootmode')
        const shadowRoot = template.parentNode.attachShadow({ mode })

        shadowRoot.appendChild(template.content)
        template.remove()
        this.attachShadowRoots(shadowRoot)
      })
    }
  }

  customElements.define('layout-stack', LayoutStack)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["layout.sticky-scroller"] && !Shopify.designMode) return;
  try {
    class StickyScroller extends HTMLElement {
    constructor() {
      super()
      this.resizeObserver = new ResizeObserver(() => this.recalculateStyles())
      this.abortController = new AbortController()
      this.isScrolling = false
      this.position = 'relative'
      this.lastKnownScrollY = 0
      this.initialTop = 0
      this.currentTop = 0
      this.boundOnScroll = this.onScroll.bind(this)
    }

    connectedCallback() {
      this.inView(this, this.setupObservers.bind(this), { margin: '500px' })
    }

    disconnectedCallback() {
      this.cleanupObservers()
    }

    setupObservers() {
      this.resizeObserver.observe(this)
      window.addEventListener('scroll', this.boundOnScroll, { passive: true, signal: this.abortController.signal })
      return this.cleanupObservers.bind(this)
    }

    cleanupObservers() {
      this.abortController.abort()
      this.resizeObserver.disconnect()
    }

    onScroll() {
      if (!this.isScrolling) {
        requestAnimationFrame(() => {
          this.updatePosition()
          this.isScrolling = false
        })
        this.isScrolling = true
      }
    }

    recalculateStyles() {
      this.style.removeProperty('top')
      const { top, position } = getComputedStyle(this)
      this.initialTop = parseInt(top, 10)
      this.position = position
      this.updatePosition()
    }

    updatePosition() {
      if (this.position !== 'sticky') {
        this.style.removeProperty('top')
        return
      }

      const { top, height } = this.getBoundingClientRect()
      const maxTop = top + window.scrollY - this.offsetTop + this.initialTop
      const minTop = height - window.innerHeight + 20

      this.currentTop += this.lastKnownScrollY - window.scrollY
      this.currentTop = Math.min(Math.max(this.currentTop, -minTop), maxTop, this.initialTop)

      this.lastKnownScrollY = window.scrollY
      this.style.top = `${Math.round(this.currentTop)}px`
    }

    /**
     * Original source from https://www.npmjs.com/package/@motionone/dom
     * Usage: https://motion.dev/dom/in-view
     */
    inView(elementOrSelector, onStart, { root, margin: rootMargin, amount = 'any' } = {}) {
      const thresholds = {
        any: 0,
        all: 1
      }

      if (typeof IntersectionObserver === 'undefined') {
        return () => {}
      }

      let elements
      if (typeof elementOrSelector === 'string') {
        elements = document.querySelectorAll(elementOrSelector)
      } else if (elementOrSelector instanceof Element) {
        elements = [elementOrSelector]
      } else {
        elements = Array.from(elementOrSelector || [])
      }

      const activeIntersections = new WeakMap()
      const onIntersectionChange = (entries) => {
        entries.forEach((entry) => {
          const onEnd = activeIntersections.get(entry.target)
          if (entry.isIntersecting === Boolean(onEnd)) return
          if (entry.isIntersecting) {
            const newOnEnd = onStart(entry)
            if (typeof newOnEnd === 'function') {
              activeIntersections.set(entry.target, newOnEnd)
            } else {
              observer.unobserve(entry.target)
            }
          } else if (onEnd) {
            onEnd(entry)
            activeIntersections.delete(entry.target)
          }
        })
      }

      const observer = new IntersectionObserver(onIntersectionChange, {
        root,
        rootMargin,
        threshold: typeof amount === 'number' ? amount : thresholds[amount]
      })

      elements.forEach((element) => observer.observe(element))
      return () => observer.disconnect()
    }
  }

  customElements.define('sticky-scroller', StickyScroller)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.drawer"] && !Shopify.designMode) return;
  try {
    function animateWithClass(element, className) {
    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      return Promise.resolve()
    }

    return new Promise((resolve) => {
      function handleAnimationEnd(event) {
        if (event.target === element) {
          element.removeEventListener('animationend', handleAnimationEnd)
          element.classList.remove(className)
          resolve()
        }
      }
      element.addEventListener('animationend', handleAnimationEnd)
      element.classList.add(className)
    })
  }

  class OverlayDrawer extends HTMLElement {
    #dialog = null
    #originalTrigger = null
    #abortController = null

    connectedCallback() {
      this.#dialog = this.querySelector('dialog')
      if (!this.#dialog) return

      this.#abortController = new AbortController()
      const { signal } = this.#abortController

      this.#dialog.addEventListener('cancel', (e) => this.#handleCancel(e), { signal })
      this.#dialog.addEventListener('click', (e) => this.#handleClick(e), { signal })
      this.#dialog.addEventListener('pointerdown', (e) => this.#handlePointerDown(e), { signal })
    }

    disconnectedCallback() {
      this.#abortController?.abort()
    }

    get lightDismiss() {
      return this.getAttribute('light-dismiss') !== 'false'
    }

    async show() {
      if (this.#dialog.open) return

      const showEvent = new CustomEvent('drawer:show', {
        bubbles: true,
        cancelable: true
      })
      this.dispatchEvent(showEvent)
      if (showEvent.defaultPrevented) return

      this.#originalTrigger = document.activeElement
      this.#dialog.showModal()

      await animateWithClass(this.#dialog, 'overlay-drawer--show')

      requestAnimationFrame(() => {
        // Only set focus if nothing inside the dialog is already focused
        if (!this.#dialog.contains(document.activeElement)) {
          const elementToFocus = this.#dialog.querySelector('[autofocus]')
          elementToFocus?.focus() ?? this.#dialog.focus()
        }
      })

      this.dispatchEvent(new CustomEvent('drawer:after-show', { bubbles: true }))
    }

    async hide(source = this) {
      if (!this.#dialog.open) return

      const hideEvent = new CustomEvent('drawer:hide', {
        bubbles: true,
        cancelable: true,
        detail: { source }
      })
      this.dispatchEvent(hideEvent)

      if (hideEvent.defaultPrevented) {
        await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        return
      }

      await animateWithClass(this.#dialog, 'overlay-drawer--hide')
      this.#dialog.close()

      if (this.#originalTrigger?.focus) {
        setTimeout(() => {
          try {
            this.#originalTrigger.focus({ preventScroll: true })
          } catch {
            this.#originalTrigger.focus()
          }
        }, 0)
      }

      this.dispatchEvent(new CustomEvent('drawer:after-hide', { bubbles: true }))
    }

    #handleCancel(event) {
      event.preventDefault()
      this.hide(this)
    }

    #handleClick(event) {
      const closeButton = event.target.closest('[data-drawer="close"]')
      if (closeButton) {
        event.stopPropagation()
        this.hide(closeButton)
      }
    }

    async #handlePointerDown(event) {
      if (event.target !== this.#dialog) return

      const rect = this.#dialog.getBoundingClientRect()
      const isClickInsideDialog =
        event.clientX >= rect.left &&
        event.clientX <= rect.right &&
        event.clientY >= rect.top &&
        event.clientY <= rect.bottom

      if (!isClickInsideDialog) {
        if (this.lightDismiss) {
          this.hide(this)
        } else {
          await animateWithClass(this.#dialog, 'overlay-drawer--pulse')
        }
      }
    }
  }

  customElements.define('overlay-drawer', OverlayDrawer)

  // Global trigger handler
  document.addEventListener('click', (event) => {
    const trigger = event.target.closest('[data-drawer]')
    if (!trigger) return

    const attr = trigger.getAttribute('data-drawer')
    if (!attr) return

    const [command, id] = attr.trim().split(/\s+/)

    if (command === 'open' && id) {
      const drawer = document.getElementById(id)
      if (drawer?.tagName === 'OVERLAY-DRAWER') {
        event.preventDefault()
        drawer.show()
      }
    }
  })

  // Safari fix for backdrop clicks
  document.body.addEventListener('pointerdown', () => {})
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["overlay.lightbox"] && !Shopify.designMode) return;
  try {
    class OverlayLightbox extends HTMLElement {
    // Static registry to track all lightbox instances
    static registry = new Map()
    // Track which groups have been prefetched
    static prefetchedGroups = new Set()

    constructor() {
      super()
      this.trigger = null
      this.template = null
      this.overlay = null
      this.closeBtn = null
      this.prevBtn = null
      this.nextBtn = null
      this.group = this.dataset.group
      this.groupItems = []
      this.currentIndex = 0

      // Register this instance
      if (this.group) {
        if (!OverlayLightbox.registry.has(this.group)) {
          OverlayLightbox.registry.set(this.group, [])
        }
        OverlayLightbox.registry.get(this.group).push(this)
      }
    }

    connectedCallback() {
      // Initialize elements when connected to DOM
      this.trigger = this.querySelector('.overlay-lightbox__trigger')
      this.template = this.querySelector('.overlay-lightbox__template')
      this.init()
    }

    init() {
      // Open lightbox on trigger click
      if (this.trigger) {
        this.trigger.addEventListener('click', (e) => {
          e.preventDefault()
          this.openLightbox()
        })
      }

      // Handle ESC key globally
      document.addEventListener('keydown', (e) => {
        if (e.key === 'Escape' && this.isOpen()) {
          this.closeLightbox()
        } else if (this.isOpen() && this.group) {
          if (e.key === 'ArrowLeft') {
            e.preventDefault()
            this.navigateToPrevious()
          } else if (e.key === 'ArrowRight') {
            e.preventDefault()
            this.navigateToNext()
          }
        }
      })
    }

    openLightbox() {
      // Create overlay if it doesn't exist
      if (!this.overlay) {
        this.createOverlay()
      }

      this.overlay.classList.add('overlay-lightbox__overlay--open')
      document.body.style.overflow = 'hidden'

      // If this is part of a group, find all group items
      if (this.group) {
        this.findGroupItems()

        // Prefetch images for the group
        this.prefetchGroupImages()

        // Add single-item class if there's only one item in the group
        if (this.groupItems.length <= 1) {
          this.overlay.classList.add('overlay-lightbox__overlay--single-item')
        } else {
          this.overlay.classList.remove('overlay-lightbox__overlay--single-item')
        }
      } else {
        // No group, so hide navigation buttons
        this.overlay.classList.add('overlay-lightbox__overlay--single-item')
      }
    }

    createOverlay() {
      // Check if template exists
      if (!this.template) {
        console.error('OverlayLightbox: Template not found')
        return
      }

      // Clone the template content
      this.overlay = this.template.content.cloneNode(true).querySelector('.overlay-lightbox__overlay')

      // Check if overlay was created successfully
      if (!this.overlay) {
        console.error('OverlayLightbox: Overlay element not found in template')
        return
      }

      // Get references to buttons
      this.closeBtn = this.overlay.querySelector('.lightbox-close')
      this.prevBtn = this.overlay.querySelector('.overlay-lightbox__nav--prev')
      this.nextBtn = this.overlay.querySelector('.overlay-lightbox__nav--next')

      // Add event listeners
      if (this.closeBtn) {
        this.closeBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.closeLightbox()
        })
      }

      if (this.prevBtn) {
        this.prevBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToPrevious()
        })
      }

      if (this.nextBtn) {
        this.nextBtn.addEventListener('click', (e) => {
          e.preventDefault()
          this.navigateToNext()
        })
      }

      // Close lightbox when clicking outside content
      if (this.overlay) {
        this.overlay.addEventListener('click', (e) => {
          if (e.target === this.overlay) {
            this.closeLightbox()
          }
        })
      }

      // Append to body
      if (this.overlay) {
        document.body.appendChild(this.overlay)
      }
    }

    closeLightbox() {
      if (this.overlay) {
        this.overlay.classList.remove('overlay-lightbox__overlay--open')
        this.overlay.classList.remove('overlay-lightbox__overlay--single-item')

        // Remove overlay immediately
        if (this.overlay.parentNode) {
          this.overlay.parentNode.removeChild(this.overlay)
          this.overlay = null
          this.closeBtn = null
          this.prevBtn = null
          this.nextBtn = null
        }
      }

      document.body.style.overflow = ''
    }

    findGroupItems() {
      // Use the static registry to find group items
      this.groupItems = OverlayLightbox.registry.get(this.group) || []
      this.currentIndex = this.groupItems.indexOf(this)
    }

    navigateToPrevious() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex - 1
      if (targetIndex < 0) {
        // Loop to last item
        targetIndex = this.groupItems.length - 1
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    navigateToNext() {
      if (!this.group || this.groupItems.length <= 1) return

      let targetIndex = this.currentIndex + 1
      if (targetIndex >= this.groupItems.length) {
        // Loop to first item
        targetIndex = 0
      }

      const targetLightbox = this.groupItems[targetIndex]
      if (targetLightbox) {
        this.switchToLightbox(targetLightbox)
      }
    }

    switchToLightbox(targetLightbox) {
      // Close current lightbox
      this.closeLightbox()

      // Open target lightbox immediately
      targetLightbox.openLightbox()
    }

    prefetchGroupImages() {
      // Only prefetch once per group
      if (this.group && !OverlayLightbox.prefetchedGroups.has(this.group)) {
        OverlayLightbox.prefetchedGroups.add(this.group)

        this.groupItems.forEach((lightbox) => {
          // Find all images in this lightbox's content
          const images = lightbox.querySelectorAll('img')
          images.forEach((img) => {
            // Prefetch the largest available image
            this.prefetchLargestImage(img)
          })
        })
      }
    }

    prefetchLargestImage(img) {
      // Try to get the largest image from srcset first
      if (img.srcset) {
        const srcsetUrls = img.srcset.split(',').map((src) => src.trim().split(' ')[0])
        // Find the largest size (highest number in the URL)
        let largestUrl = img.src
        let largestSize = 0

        srcsetUrls.forEach((url) => {
          const size = this.extractImageSize(url)
          if (size > largestSize) {
            largestSize = size
            largestUrl = url
          }
        })

        this.prefetchImage(largestUrl)
      } else {
        // No srcset, try to get largest size from original URL
        const largestUrl = this.getLargestImageUrl(img.src)
        this.prefetchImage(largestUrl)
      }
    }

    extractImageSize(url) {
      try {
        const urlObj = new URL(url)

        // Check for width parameter
        if (urlObj.searchParams.has('width')) {
          return parseInt(urlObj.searchParams.get('width')) || 0
        }

        // Check for underscore format (image_2400x.jpg)
        const pathParts = urlObj.pathname.split('_')
        if (pathParts.length > 1) {
          const sizeMatch = pathParts[pathParts.length - 1].match(/(\d+)x/)
          if (sizeMatch) {
            return parseInt(sizeMatch[1]) || 0
          }
        }
      } catch (e) {
        // URL parsing failed
      }

      return 0
    }

    getLargestImageUrl(originalUrl) {
      try {
        const url = new URL(originalUrl)

        // Handle Shopify image URLs - try to get 2400px version
        if (url.searchParams.has('width')) {
          url.searchParams.set('width', '2400')
          return url.toString()
        } else if (url.pathname.includes('_')) {
          // Handle Shopify's underscore format
          const pathParts = url.pathname.split('_')
          if (pathParts.length > 1) {
            const extension = pathParts[pathParts.length - 1].split('.')[1] || 'jpg'
            const newPath = pathParts.slice(0, -1).join('_') + '_2400x.' + extension
            url.pathname = newPath
            return url.toString()
          }
        }
      } catch (e) {
        // If URL parsing fails, return original
      }

      return originalUrl
    }

    prefetchImage(url) {
      const prefetchImg = new Image()
      prefetchImg.src = url
    }

    isOpen() {
      return this.overlay && this.overlay.classList.contains('overlay-lightbox__overlay--open')
    }

    // Clean up when element is removed
    disconnectedCallback() {
      if (this.group) {
        const groupItems = OverlayLightbox.registry.get(this.group)
        if (groupItems) {
          const index = groupItems.indexOf(this)
          if (index > -1) {
            groupItems.splice(index, 1)
          }
          // Remove empty groups
          if (groupItems.length === 0) {
            OverlayLightbox.registry.delete(this.group)
          }
        }
      }
    }
  }

  // Define the custom element
  customElements.define('overlay-lightbox', OverlayLightbox)
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["product.hot-reload"] && !Shopify.designMode) return;
  try {
    class ProductHotReload extends HTMLElement {
    constructor() {
      super()
      this.cache = new Map() // Cache for pre-fetched content
      this.activeRequests = new Map() // Track active fetch requests
      this.loadingTimeout = null // Timeout for loading state
      this.supportsViewTransitions = 'startViewTransition' in document

      this.addEventListener('change', (event) => this.onVariantChange(event))
      this.addEventListener('mouseover', (event) => this.onMouseOver(event))
    }

    showLoadingState() {
      // Start loading state (pulse) after 200ms
      this.loadingTimeout = setTimeout(() => {
        this.classList.add('product-hot-reload--loading')
      }, 200)
    }

    hideLoadingState() {
      // Clear the timeout if it hasn't triggered yet
      if (this.loadingTimeout) {
        clearTimeout(this.loadingTimeout)
        this.loadingTimeout = null
      }

      // Remove loading animation
      this.classList.remove('product-hot-reload--loading')
    }

    buildRequestUrl(input) {
      const productFormElement = input.closest('form')
      const sectionId = this.dataset.sectionId

      // Get dataset values from the input or selected option
      let newProductUrl, optionValueId

      if (input.type === 'radio') {
        newProductUrl = input.dataset.productUrl
        optionValueId = input.dataset.optionValueId
      } else if (input.tagName === 'SELECT') {
        const selectedOption = input.options[input.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl
        optionValueId = selectedOption.dataset.optionValueId
      }

      // Get all currently selected values from both radio inputs and select elements
      let selectedOptionValues = []

      // Get values from checked radio inputs
      const checkedRadios = Array.from(productFormElement.querySelectorAll('input[type="radio"]:checked'))
      selectedOptionValues = checkedRadios.map(({ dataset }) => dataset.optionValueId).filter(Boolean)

      // Get values from select elements
      const selects = Array.from(productFormElement.querySelectorAll('select'))
      selects.forEach((select) => {
        const selectedOption = select.options[select.selectedIndex]
        if (selectedOption && selectedOption.dataset.optionValueId) {
          selectedOptionValues.push(selectedOption.dataset.optionValueId)
        }
      })

      // If we're building for a hover state, replace the current option's value
      if (input.type === 'radio' && !input.checked) {
        const currentOptionName = input.name
        // Remove any existing selection for this option
        selectedOptionValues = selectedOptionValues.filter((id) => {
          const input = productFormElement.querySelector(`input[data-option-value-id="${id}"]`)
          return input && input.name !== currentOptionName
        })
        // Add the hovered option value
        selectedOptionValues.push(optionValueId)
      }

      const params = selectedOptionValues.length > 0 ? `&option_values=${selectedOptionValues.join(',')}` : ''
      return `${newProductUrl}?section_id=${sectionId}${params}`
    }

    onMouseOver(event) {
      const label = event.target.closest('label')
      if (!label) return

      const input = label.querySelector('input[type="radio"]')
      if (!input) return

      // Don't pre-fetch if already selected
      if (input.checked) return

      const requestUrl = this.buildRequestUrl(input)

      // Don't prefetch if we already have cached content or an active request
      if (this.cache.has(requestUrl) || this.activeRequests.has(requestUrl)) return

      // Pre-fetch the content for this option
      this.fetchContent(requestUrl)
    }

    fetchContent(requestUrl) {
      // Create and store the fetch promise
      const fetchPromise = fetch(requestUrl)
        .then((response) => response.text())
        .then((responseText) => {
          const html = new DOMParser().parseFromString(responseText, 'text/html')
          this.cache.set(requestUrl, html)
          this.activeRequests.delete(requestUrl)
          return html
        })
        .catch((error) => {
          this.activeRequests.delete(requestUrl)
          throw error
        })

      this.activeRequests.set(requestUrl, fetchPromise)
      return fetchPromise
    }

    async onVariantChange(event) {
      if (!event.target.hasAttribute('data-product-hot-reload-trigger')) return

      const optionValueElement = event.target
      const requestUrl = this.buildRequestUrl(optionValueElement)
      const oldProductUrl = this.dataset.productUrl

      // Get new product URL from the input or selected option
      let newProductUrl
      if (optionValueElement.type === 'radio') {
        newProductUrl = optionValueElement.dataset.productUrl || oldProductUrl
      } else if (optionValueElement.tagName === 'SELECT') {
        const selectedOption = optionValueElement.options[optionValueElement.selectedIndex]
        newProductUrl = selectedOption.dataset.productUrl || oldProductUrl
      } else {
        newProductUrl = oldProductUrl
      }

      // Start loading state immediately on change event
      this.showLoadingState()

      let html

      try {
        // Use cached content if available
        if (this.cache.has(requestUrl)) {
          html = this.cache.get(requestUrl)
        }
        // Wait for active request if one exists
        else if (this.activeRequests.has(requestUrl)) {
          html = await this.activeRequests.get(requestUrl)
        }
        // Make new request if no cache or active request
        else {
          html = await this.fetchContent(requestUrl)
        }

        await this.updateProductWithTransition(html, newProductUrl, event.target.id)
      } catch (error) {
        console.error('Error updating product content:', error)
      } finally {
        // Always hide loading state
        this.hideLoadingState()
      }
    }

    async updateProductWithTransition(html, newProductUrl, targetId) {
      const updatedHtml = html.getElementById(this.id)

      if (this.supportsViewTransitions) {
        // Use View Transitions API for smooth transitions
        const transition = document.startViewTransition(() => {
          this.innerHTML = updatedHtml.innerHTML
          this.dataset.productUrl = updatedHtml.dataset.productUrl
          this.dataset.variantId = updatedHtml.dataset.variantId
        })

        // Wait for the transition to complete
        await transition.finished
      } else {
        // Fallback: Update content immediately without animations
        this.innerHTML = updatedHtml.innerHTML
        this.dataset.productUrl = updatedHtml.dataset.productUrl
        this.dataset.variantId = updatedHtml.dataset.variantId
      }

      // Update URL and history
      let url = new URL(newProductUrl, window.location.origin)

      // Preserve all existing URL parameters from the current page
      const currentUrl = new URL(window.location.href)
      for (const [key, value] of currentUrl.searchParams.entries()) {
        // Don't override the variant parameter we're setting
        if (key !== 'variant') {
          url.searchParams.set(key, value)
        }
      }

      // Add variant param if variantId exists
      url.searchParams.set('variant', this.dataset.variantId)

      // Push new state to browser history
      window.history.pushState({}, '', url.toString())

      // Focus the input for the last clicked option value
      this.querySelector(`#${targetId}`).focus()
    }
  }

  customElements.define('product-hot-reload', ProductHotReload)
  } catch(e) { console.error(e); }
})();

})();
